// extracted by mini-css-extract-plugin
export default {"versionCardBody":"versionCardBody---a1zVQ","changedRecordsList":"changedRecordsList---LQbyG","changedRecord":"changedRecord---H4ZNn"};